export default '__THEMING__';


// WEBPACK FOOTER //
// ../node_modules/theming/dist/esm/channel.js